

import { AppointmentFormSchemaType } from "../../state/createAppointmentData/createAppointment.reducer";
import { IAppointmentCreateRequest, IPetDataInputForm } from "./create-appointment-v2.interface";

function formatPetDetailsWithReason(inputObject: { [key: string]: IPetDataInputForm }, promoCode?: string[]) {
  return Object.entries(inputObject).map(([petId, details]) => {
    const socReasons = details.socReasons?.toString() ? details.socReasons.toString() + "," : "";

    let reasons = "";

    if (!details.socReasons?.toString()) {
      reasons = details.reasons ? details.reasons.toString() : "";
    } else {
      reasons = `${details.reasons ? "reasons:" + details.reasons.toString() : ""}`;
    }

    return {
      petId,
      reasonsForVisit: details.socReasons ? socReasons + reasons: reasons,
      promoCode,
    };
  });
}
export const mapToAppointmentCreateRequest = (
  appointmentForm: AppointmentFormSchemaType,
  petDataInput: { [key: string]: IPetDataInputForm },
  appointmentCreateType: Number,
  promoCode?: string[],
): IAppointmentCreateRequest => {
  const pets = formatPetDetailsWithReason(petDataInput, promoCode);

  return {
    pets,
    start_at: appointmentForm.time,
    sales_resource: +appointmentForm.resourcesId,
    locationId: appointmentForm.location as string,
    appointmentFrom: "Web",
    appointmentCreateType,
  };
};
